import { useState } from 'react';

import { RegisterFields } from '@playbooks/components/auth/register-fields';
import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { AuthBrand } from 'components/auth/auth-brand';
import { AuthDivider } from 'components/auth/auth-divider';
import { AuthFormShell } from 'components/auth/auth-form-shell';
import { AuthProviderActions } from 'components/auth/auth-provider-actions';
import { useStore } from 'contexts';
import { useAction } from 'hooks';

const RegisterForm = ({ onBack, onNext, onView }) => {
	const [user, setUser] = useState<any>({});
	const store = useStore();

	// Hooks
	const [onSave, saveTask] = useAction(async () => {
		const response = await store.createRecord({ url: '/auth/register', data: user });
		await onNext(response.data);
	});

	// Methods
	const onSubmit = e => {
		e.preventDefault();
		onSave();
	};

	// Render
	return (
		<AuthFormShell onSubmit={onSubmit} className='space-y-5'>
			<Button type='button' variant='outline' size='icon-xs' aria-label='Back to sign-in options' onClick={onBack}>
				<Icon type='far' icon='chevron-left' aria-hidden />
			</Button>
			<AuthBrand title='Create your account' description='Start with a personal workspace' />
			<div className='flex-column gap-4'>
				<RegisterFields user={user} setUser={setUser} />
				<Button type='submit' size='lg' isLoading={saveTask.running} className='w-full'>
					Create account
				</Button>
			</div>
			<AuthDivider>or continue with</AuthDivider>
			<AuthProviderActions compact onNext={onNext} />
			<p className='text-center text-xs text-foreground-subtle'>
				Already have an account?{' '}
				<Link
					variant='link'
					href='/auth?view=login'
					onClick={e => (e.preventDefault(), onView('login'))}
					className='inline h-auto p-0 text-action'>
					Log in
				</Link>
			</p>
		</AuthFormShell>
	);
};

export { RegisterForm };
